export default function ModalCloseIcon({ height = '35', width = '35' }) {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 34 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="17" cy="17.422" rx="17" ry="17.326" fill="#292929" />
      <path
        d="M23 11.3069L11 23.537M23 23.537L11 11.3069L23 23.537Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}
